import {
  CLEAR_AUDITS,
  GET_AUDIT_LIST_FAILURE,
  GET_AUDIT_LIST_REQUEST,
  GET_AUDIT_LIST_SUCCESS,
} from "actions/audit";

const initialState = {
  loading: false,
  error: {},
  unitAuditList: [],
  unitAuditTotalCount: 0,
  siteAuditList: [],
  siteAuditTotalCount: 0,
};

export default function audit(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_AUDIT_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_AUDIT_LIST_SUCCESS: {
      const { entity_type, items = [], total_count } = payload;

      const listKey =
        entity_type === "unit" ? "unitAuditList" : "siteAuditList";
      const totalCountKey =
        entity_type === "unit" ? "unitAuditTotalCount" : "siteAuditTotalCount";

      return {
        ...state,
        loading: false,
        [listKey]: items.map((it, i) => {
          return {
            ...it,
            id: i,
          };
        }),
        [totalCountKey]: total_count,
      };
    }

    case GET_AUDIT_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case CLEAR_AUDITS: {
      return {
        ...state,
        ...initialState,
      };
    }

    default:
      return state;
  }
}
